import { Injectable } from '@angular/core';
import { BaseService } from '../../common/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SelectBy } from '../../common/interfaces/sort-by.interface';
import { Address } from '../../common/interfaces/address.interface';
import { Pageable } from '../../common/interfaces/pageable.interface';

@Injectable()
export class CommonAddressService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    findAll(state: string, searchValue?: string): Observable<Address[]> {
        const sortBy: SelectBy = {order: 'ASCENDING', type: 'NAME'};
        let params = this.getSortHeaders(sortBy);
        params = params.append('state', state);
        params = params.append('size', '50');
        if (searchValue) {
            params = params.append('freeTextSearch', searchValue);
        }
        return this.http.get(this.getApiUrl() + '/address/overview', { params })
            .pipe(map((res: Pageable) => res.content || []));
    }

    findAllPageable(page: number, state: string, search?: string, size?: number): Observable<Pageable> {
        const sortBy: SelectBy = {order: 'ASCENDING', type: 'NAME'};
        let params = this.getSortHeaders(sortBy);
        params = params.append('state', state);
        params = params.append('size', size ? size.toString() : '50');
        params = params.append('page', page.toString());
        if (search) {
            params = params.append('freeTextSearch', search);
        }

        return this.http.get(this.getApiUrl() + '/address/overview', { params })
            .pipe(map((res: Pageable) => res || {content: []}));
    }

    create(address: Address): Observable<any> {
        const body = this.cloneAndRemoveNulls(address);
        return this.http.post(this.getApiUrl() + '/address', body);
    }
}
